import classNames from 'classnames';
import React from 'react';
import { Size } from '../../../constants/commonEnums';

// Card with following props -
// 1. BG Color
// 2. Padding
// 3. Rounded Borders
// 4. Shadows

const classNamesConfig = {
  cardBorder: 'border border-solid border-gray-200',
  cardBorderDashed: 'border-dashed',
};

const ROUNDED_MAPS: Record<Size, string> = {
  [Size.XSMALL]: 'rounded-xs',
  [Size.SMALL]: 'rounded-sm',
  [Size.LARGE]: 'rounded-lg',
  [Size.MEDIUM]: 'rounded-md',
  [Size.XLARGE]: 'rounded-xl',
};

const PADDING: Record<Size, string> = {
  [Size.XSMALL]: 'p-2',
  [Size.SMALL]: 'p-4',
  [Size.LARGE]: 'p-8',
  [Size.MEDIUM]: 'p-6',
  [Size.XLARGE]: 'p-10',
};

interface CardProps extends React.PropsWithChildren {
  rounded?: Size;
  padding?: Size;
  border?: boolean;
  dashed?: boolean;
  onClick?: React.EventHandler<React.MouseEvent | React.TouchEvent>;
  className?: string;
}

const Card: React.FC<CardProps> = ({
  rounded = Size.LARGE,
  padding = Size.LARGE,
  border = false,
  dashed = false,
  className = '',
  onClick = () => {
    // do nothing
  },
  children = null,
}) => {
  const cardClasses = classNames({
    [classNamesConfig.cardBorder]: border,
    [classNamesConfig.cardBorderDashed]: dashed,
    [`${className}`]: className,
  });
  return (
    <div
      data-testid="Card"
      className={`${ROUNDED_MAPS[rounded]} ${PADDING[padding]} ${cardClasses}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export { Card };
